import { render, staticRenderFns } from "./DialogGateway.vue?vue&type=template&id=37fc6ed8&"
import script from "./DialogGateway.vue?vue&type=script&lang=js&"
export * from "./DialogGateway.vue?vue&type=script&lang=js&"
import style0 from "./DialogGateway.vue?vue&type=style&index=0&id=37fc6ed8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports